import {isLoggedIn} from '../../utils/auth'
import {injectReducer} from '../../store/reducers'
import {loadCustomerOffersReducer, validateOTPReducer} from './modules/OfferActivation'
import {sendOtpReducer} from "../LoyaltyRedeem/modules/LoyaltyRedeem";

export default (store) => ({
  path: 'offer-activation',
  onEnter: isLoggedIn(store),
  /*  Async getComponent is only invoked when route matches   */
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const CustomerDetails = require('./containers/OfferActivation').default
      injectReducer(store, {key: 'customerOffers', reducer: loadCustomerOffersReducer})
      injectReducer(store, {key: 'validatedOtpInfo', reducer: validateOTPReducer})
      cb(null, CustomerDetails)
      /* Webpack named bundle   */
    }, 'categoryDetails')
  }
})



// WEBPACK FOOTER //
// ./src/routes/OfferActivation/index.js